import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CashEntryDetail } from '../../Models/Domains/Transactions/Cash/CashEntryDetail';

declare var IS_RUNNING_IN_APP_POOL;

export class CashEntryDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(cashId: number): Promise<Array<CashEntryDetail>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/CashEntryDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { cashId: cashId }

    return AjaxWrapper.get<Array<CashEntryDetail>, any>(url, data);
  }
}

